import { createSelector } from 'reselect'

import { FETCH_STATUS } from '../constants'

import { NAME } from './reducer'

const byIdSelector = state => state[NAME].byId
const visible = state => state[NAME].visible
const selected = state => state[NAME].selected
const hovered = state => state[NAME].hovered
export const getIsLoading = state =>
  state[NAME].fetchStatus === FETCH_STATUS.FETCHING
export const getIsClean = state => state[NAME].clean
export const getLayerIds = state => state[NAME].allKeys
export const getBufferByLayerId = createSelector(
  byIdSelector,
  bufferById => layerId => bufferById[layerId] || null
)
export const getBuffers = createSelector(
  [getLayerIds, getBufferByLayerId],
  (ids, byId) => ids.map(byId)
)
export const getSelectedByLayerId = createSelector(
  [selected],
  selected => layerId => selected === layerId
)

export const getSelectedBuffer = createSelector(
  [selected, getBufferByLayerId],
  (selected, byId) => byId(selected)
)

export const getVisibleByLayerId = createSelector(
  [visible],
  visible => layerId => visible[layerId] || false
)

export const getVisibleLayerIds = createSelector(
  [getLayerIds, getVisibleByLayerId],
  (allKeys, isVisible) => allKeys.filter(isVisible)
)

export const getVisibleBuffers = createSelector(
  [getVisibleLayerIds, byIdSelector],
  (layerIds, bufferById) => layerIds.map(bufferById)
)

export const getEditor = state => state[NAME].editor
export const getEditorIsOpen = createSelector(
  [getEditor],
  editor => editor.open
)
export const getEditorMode = createSelector([getEditor], editor => editor.mode)
export const getEditorBuffer = createSelector(
  [getEditor],
  editor => editor.buffer
)

export const getHoveredBuffer = createSelector(
  [hovered, getBufferByLayerId],
  (hovered, byId) => (hovered === null ? null : byId(hovered))
)
